import { IContractHistoryDTO } from "@/interface"
import { OrderStatusTypeEnum, OrderTypeEnum } from "@/enums"
import { getNewOrderStore } from "@/helpers/storeHelpers"

export class ContractHistory {
    public id: number;
    public order_id: string;
    public order_date: Date;
    public order_type: string;
    public resource_name: string|null;
    public old_value: string|null;
    public new_value: string|null;
    public status: string;
    public reason_error: string|null;
    public error: string|null;
    public isCancellable: boolean;
    public isCancellableOption: boolean;
    public initiatorRef: string|null;
    public initiatorType: string|null;
    public scheduled_date: Date|null;

    constructor(base?: Partial<ContractHistory>){
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IContractHistoryDTO) {
        if (!dto) {
            return null;
        }

        const newOrderStore = getNewOrderStore()

        return new ContractHistory({
            id: dto.id,
            order_id: dto.order_id,
            order_date: new Date(dto.order_date),
            order_type: dto.order_type,
            resource_name: dto.resource_name,
            old_value: dto.old_value,
            new_value: dto.new_value,
            status: dto.status,
            reason_error: dto.reason_error,
            error: dto.error === "null" ? null : dto.error,
            isCancellable: dto.isCancellable,
            isCancellableOption: dto.order_id !== (newOrderStore?.getOrderPendingId ?? '') && dto.order_type === OrderTypeEnum.OPTION && dto.status === OrderStatusTypeEnum.PENDING,
            initiatorRef: dto.initiatorRef,
            initiatorType: dto.initiatorType,
            scheduled_date: dto.scheduled_date ? new Date(dto.scheduled_date) : null
        });
    }
}